/**
 * The WATCH screen at the demonstrator anchor: 9:35 p.m. ET on April 6, 2026.
 * These are live game states, not the replay/UK availability shown in the
 * later NBA-app layout capture.
 */
export const anchorWatchChannels = [
    {
        accessLabel: "Watch on Peacock",
        detail: "New York leads 106–105. Atlanta has the ball.",
        gameId: "0022501143",
        headline: "One point. 1.2 seconds.",
        id: "nyk-atl",
        isNational: true,
        matchup: "Knicks at Hawks",
        score: "NYK 106–105 ATL",
        state: "Q4 · 1.2",
    },
    {
        accessLabel: "Tap To Watch",
        detail: "Orlando leads by 16 after answering a rally that cut the margin to three.",
        gameId: "0022501144",
        headline: "Orlando answers Detroit’s last push.",
        id: "det-orl",
        isNational: false,
        matchup: "Pistons at Magic",
        score: "DET 107–123 ORL",
        state: "Q4 · 55.2",
    },
    {
        accessLabel: "Tap To Watch",
        detail: "The Cavaliers have turned a 17-point deficit into a 12-point lead.",
        gameId: "0022501145",
        headline: "Cleveland turns 17 down into 12 up.",
        id: "cle-mem",
        isNational: false,
        matchup: "Cavaliers at Grizzlies",
        score: "CLE 89–77 MEM",
        state: "Q3 · 4:49",
    },
    {
        accessLabel: "Tap To Watch",
        detail: "Wembanyama has 17 points and three blocks; Embiid has 20 points.",
        gameId: "0022501146",
        headline: "Wemby and Embiid carry the matchup into the third.",
        id: "phi-sas",
        isNational: false,
        matchup: "76ers at Spurs",
        score: "PHI 65–74 SAS",
        state: "Q3 · 8:17",
    },
    {
        accessLabel: "Tap To Watch",
        detail: "The Trail Blazers have made nine first-quarter threes.",
        gameId: "0022501147",
        headline: "Nine Portland threes open the late game.",
        id: "por-den",
        isNational: false,
        matchup: "Trail Blazers at Nuggets",
        score: "POR 35–31 DEN",
        state: "Q1 · 0:00",
    },
];
export const anchorWatchActionLabelByGameId = Object.fromEntries(anchorWatchChannels.map((channel) => [
    channel.gameId,
    channel.accessLabel,
]));
/**
 * Eastern Conference standings before the April 6 games became final.
 * Percentage and games back are derived directly from the verified W-L
 * records, using Detroit (57-21) as the conference leader.
 */
export const anchorEasternConferenceStandings = [
    {
        code: "DET",
        gamesBack: "—",
        losses: 21,
        name: "Pistons",
        percentage: ".731",
        rank: 1,
        wins: 57,
    },
    {
        code: "BOS",
        gamesBack: "4",
        losses: 25,
        name: "Celtics",
        percentage: ".679",
        rank: 2,
        wins: 53,
    },
    {
        code: "NYK",
        gamesBack: "7",
        losses: 28,
        name: "Knicks",
        percentage: ".641",
        rank: 3,
        wins: 50,
    },
    {
        code: "CLE",
        gamesBack: "8",
        losses: 29,
        name: "Cavaliers",
        percentage: ".628",
        rank: 4,
        wins: 49,
    },
    {
        code: "ATL",
        gamesBack: "12",
        losses: 33,
        name: "Hawks",
        percentage: ".577",
        rank: 5,
        wins: 45,
    },
    {
        code: "PHI",
        gamesBack: "14",
        losses: 35,
        name: "76ers",
        percentage: ".551",
        rank: 6,
        wins: 43,
    },
    {
        code: "TOR",
        gamesBack: "14",
        losses: 35,
        name: "Raptors",
        percentage: ".551",
        rank: 7,
        wins: 43,
    },
    {
        code: "CHA",
        gamesBack: "14.5",
        losses: 36,
        name: "Hornets",
        percentage: ".544",
        rank: 8,
        wins: 43,
    },
    {
        code: "ORL",
        gamesBack: "15",
        losses: 36,
        name: "Magic",
        percentage: ".538",
        rank: 9,
        wins: 42,
    },
    {
        code: "MIA",
        gamesBack: "16",
        losses: 37,
        name: "Heat",
        percentage: ".526",
        rank: 10,
        wins: 41,
    },
    {
        code: "MIL",
        gamesBack: "26",
        losses: 47,
        name: "Bucks",
        percentage: ".397",
        rank: 11,
        wins: 31,
    },
    {
        code: "CHI",
        gamesBack: "28",
        losses: 49,
        name: "Bulls",
        percentage: ".372",
        rank: 12,
        wins: 29,
    },
    {
        code: "BKN",
        gamesBack: "38",
        losses: 59,
        name: "Nets",
        percentage: ".244",
        rank: 13,
        wins: 19,
    },
    {
        code: "IND",
        gamesBack: "39",
        losses: 60,
        name: "Pacers",
        percentage: ".231",
        rank: 14,
        wins: 18,
    },
    {
        code: "WAS",
        gamesBack: "40",
        losses: 61,
        name: "Wizards",
        percentage: ".218",
        rank: 15,
        wins: 17,
    },
];
